import React from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../RadioGroup/RadioGroup';
import { useFormContext } from './FormProvider';
import PropTypes from 'prop-types';
import { createStyles } from "antd-style";

const useStyles = createStyles(({ css }) => ({
  radioGroup: css`
    .ant-form-item {
      .ant-row {
        .ant-radio-group {
          display: flex;
          .ant-radio-button-wrapper {
            width: 100%;
            text-align: center;
          }
        }
      }
    }
  `,
}));

export const FormRadioGroup = ({ name, ...props }) => {
  const { control, formConfig } = useFormContext();
  const { styles } = useStyles();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className={styles.radioGroup}>
          <RadioGroup
            {...field}
            {...formConfig}
            {...props}
            error={!!error}
            helperText={error?.message ? error?.message : props.helperText}
          />
        </div>
      )}
    />
  );
};

FormRadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
}; 